module.exports = __webpack_public_path__ + "static/media/external-link.905347be.svg";